module.exports = __webpack_public_path__ + "856c733ef74bd93c6c07d34901db1822.svg";